const trackedGuids = new Set()
const HUBSPOT_PORTAL_ID = '9226978'

export async function trackHubSpotFormSubmit({ email, formGuid, formName }) {
  try {
    if (!email || !formGuid) return
    if (trackedGuids.has(formGuid)) return
    const clean = String(email).toLowerCase().trim()
    if (!clean) return
    trackedGuids.add(formGuid)

    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(clean))
    const hashHex = Array.from(new Uint8Array(buf))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('')

    if (typeof window.gtag === 'function') {
      window.gtag('set', { user_id: hashHex })
      window.gtag('event', 'hubspot_form_submit', {
        user_id: hashHex,
        form_id: formGuid,
        form_name: formName || 'unknown',
        hubspot_portal_id: HUBSPOT_PORTAL_ID,
      })
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'hubspot_form_submit',
      user_id: hashHex,
      email_hash: hashHex,
      form_id: formGuid,
      form_name: formName || 'unknown',
    })
  } catch (err) {
    if (typeof console !== 'undefined') console.warn('[trackHubSpotFormSubmit]', err)
  }
}

export function initHubSpotFormStitching(formNames = {}) {
  if (typeof window === 'undefined') return

  window.addEventListener('message', event => {
    try {
      const d = event && event.data
      if (!d || d.type !== 'hsFormCallback') return
      if (d.eventName !== 'onFormSubmit' && d.eventName !== 'onFormSubmitted') return
      const formGuid = d.id || (d.data && d.data.formGuid)
      const values = (d.data && d.data.submissionValues) || {}
      const email = values.email
      if (formGuid && email) {
        trackHubSpotFormSubmit({ email, formGuid, formName: formNames[formGuid] })
      }
    } catch (err) {
      if (typeof console !== 'undefined') console.warn('[hsFormCallback listener]', err)
    }
  })

  if (typeof document === 'undefined') return
  const attach = formEl => {
    if (formEl.dataset.stitchingAttached === 'true') return
    formEl.dataset.stitchingAttached = 'true'
    const guid = (formEl.id || '').replace(/^hsForm_/, '').split('_')[0]
    formEl.addEventListener(
      'submit',
      () => {
        const emailInput = formEl.querySelector('input[type="email"], input[name="email"]')
        const email = emailInput && emailInput.value
        if (email && guid) {
          trackHubSpotFormSubmit({ email, formGuid: guid, formName: formNames[guid] })
        }
      },
      { capture: true }
    )
  }
  const sweep = () => document.querySelectorAll('form.hs-form').forEach(attach)
  if (document.body) sweep()
  const obs = new MutationObserver(sweep)
  const startObserving = () => {
    if (document.body) obs.observe(document.body, { childList: true, subtree: true })
  }
  if (document.body) startObserving()
  else document.addEventListener('DOMContentLoaded', startObserving, { once: true })
}
